export default "/images/79b1356465b5cbefc2584b1a68a7d1d8.avif";